// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reservations_reservationContainer__dWiwu {
    background-color: #495E57;
}

.reservations_reservationContainer__dWiwu h1 {
    text-align: center;
}

.reservations_reservationContainer__dWiwu > section {
    align-items: center;
}

.reservations_reservationContainer__dWiwu > section > section {
    min-width: 300px;
    width: 501px;
}`, "",{"version":3,"sources":["webpack://./src/components/Reservations/reservations.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".reservationContainer {\n    background-color: #495E57;\n}\n\n.reservationContainer h1 {\n    text-align: center;\n}\n\n.reservationContainer > section {\n    align-items: center;\n}\n\n.reservationContainer > section > section {\n    min-width: 300px;\n    width: 501px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reservationContainer": `reservations_reservationContainer__dWiwu`
};
export default ___CSS_LOADER_EXPORT___;
